import request from '@/utils/request'

// 锁定号源支付订单
export function setOrderPay(data) {
	return request({
		url: '/api/order/pay',
		method: 'post',
		data,
	})
}

// 获取医院详情
export function getHospitalDetail(opt) {
	return request({
		url: '/api/hospital/' + opt,
		method: 'get',
	})
}

// 订单详情
export function getOrderDetail(opt, data) {
	return request({
		url: '/api/order/getOrder/' + opt,
		method: 'get',
		params: data,
	})
}
// 支付0元订单
export function setResult0(data) {
	return request({
		url: '/api/pay/result/zero',
		method: 'post',
		data,
	})
}
// 创建支付订单
export function setWxOrder(data) {
	return request({
		url: '/api/order/createWxOrder',
		method: 'post',
		data,
	})
}

// 获取支付宝支付是否成功
export function getAlipayStatus(opt) {
	return request({
		url: '/api/order/getAlipayStatus/' + opt,
		method: 'get',
	})
}

//退款
export function startRefund(data) {
	return request({
		url: '/api/order/startRefund',
		method: 'post',
		data,
	})
}

// 判断当前医院是否在挂号提交界面是否显示有预约来源选项
export function checkYuyueFrom(data) {
	return request({
		url: '/api/hospital/checkYuyueFrom',
		method: 'get',
		params: data,
	})
}
